// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"351":"d86696b0","984":"98692049"}[chunkId] + ".chunk.css";
};